import { useEffect } from 'react';
import ScaffoldPage from '../_ScaffoldPage';
export default function FixedIncomeTrackerPage() {
  useEffect(() => { document.title = 'Fixed Income Tracker — Yield Curves & Bond Rates for 28 Countries | Nuvport OS'; }, []);
  return <ScaffoldPage badge="FIXED INCOME" title="Track yield curves and bond rates across 28 countries." description="Monitor government bond rates, yield curve shape, and fixed income signals across 28 bond-issuing countries. Spot inversions before they hit the news." canonical="/features/fixed-income-tracker" />;
}
